import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AvatarModule } from 'src/app/components/avatar/avatar.module';
import { FilterButtonComponent } from 'src/app/components/filter-button/filter-button.component';
import { SharedDirectivesModule } from 'src/directives/shared-directives.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { CustomerListPageRoutingModule } from './customer-list-routing.module';
import { CustomerListPage } from './customer-list.page';

@NgModule({
  imports: [
    SharedDirectivesModule,
    CommonModule,
    FormsModule,
    IonicModule,
    NgxDatatableModule,
    AvatarModule,
    SharedPipesModule,
    CustomerListPageRoutingModule,
    NgxTippyModule,
    FilterButtonComponent,
  ],
  declarations: [CustomerListPage],
})
export class CustomerListPageModule {}
